import { AfterViewInit, Directive, ElementRef } from '@angular/core';

@Directive({
  selector: '[enableSpellcheck]',
  standalone: true,
})
export class EnableSpellcheckDirective implements AfterViewInit {
  constructor(private el: ElementRef<HTMLElement>) {}

  ngAfterViewInit(): void {
    const input = this.el.nativeElement.querySelector('input');
    if (input) {
      input.setAttribute('spellcheck', 'true');
    }
  }
}
